import { Box, Skeleton, Typography } from "@mui/material";
import {
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LineChart,
} from "recharts";

const SERIES = [
  { key: "collections", name: "Collections", color: "#1D9E75" },
  { key: "payout", name: "Payout", color: "#534AB7" },
];

const formatVolume = (value) => {
  if (value >= 1_000_000_000) return `₦${(value / 1_000_000_000).toFixed(1)}B`;
  if (value >= 1_000_000) return `₦${(value / 1_000_000).toFixed(0)}M`;
  return `₦${value.toLocaleString()}`;
};

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <Box
      sx={{
        background: "background.paper",
        border: "0.5px solid",
        borderColor: "divider",
        borderRadius: 1.5,
        p: 1.5,
        minWidth: 160,
      }}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        display="block"
        mb={0.5}
      >
        {label}
      </Typography>
      {payload.map((entry) => (
        <Box
          key={entry.dataKey}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                bgcolor: entry.color,
                flexShrink: 0,
              }}
            />
            <Typography variant="caption" color="text.secondary">
              {entry.name}
            </Typography>
          </Box>
          <Typography variant="caption" fontWeight={500}>
            {formatVolume(entry.value)}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export const TrendChart = ({ data, isLoading }) => {
  if (isLoading) return <Skeleton variant="rectangular" height={260} />;
  if (!data) return null;

  return (
    <ResponsiveContainer width="100%" height={260}>
      <LineChart
        data={data.series}
        margin={{ top: 4, right: 16, left: 0, bottom: 0 }}
      >
        <CartesianGrid
          strokeDasharray="3 3"
          stroke="rgba(0,0,0,0.06)"
          vertical={false}
        />
        <XAxis
          dataKey="label"
          tick={{ fontSize: 11, fill: "#888780" }}
          axisLine={false}
          tickLine={false}
        />
        <YAxis
          tickFormatter={formatVolume}
          tick={{ fontSize: 11, fill: "#888780" }}
          axisLine={false}
          tickLine={false}
          width={56}
        />
        <Tooltip content={<CustomTooltip />} />
        <Legend
          iconType="circle"
          wrapperStyle={{ fontSize: 12, paddingTop: 8 }}
        />
        {SERIES.map((s) => (
          <Line
            key={s.key}
            dataKey={s.key}
            name={s.name}
            type="monotone"
            stroke={s.color}
            strokeWidth={2}
            dot={{ r: 3, fill: s.color, strokeWidth: 0 }}
            activeDot={{ r: 5 }}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};
